<template>
  <FieldWrapper
    :block="block"
    :step="step"
    v-on:update="update"
    @delete="$emit('delete')"
    label="Champ date"
    v-on:up="$emit('up')"
    v-on:down="$emit('down')"
  >
    <template v-slot:view>
      <v-list dense>
        <v-list-item>
          <v-list-item-content>Nom du champ:</v-list-item-content>
          <v-list-item-content class="align-end">{{ block.fieldObject.name }}</v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>Etiquette:</v-list-item-content>
          <v-list-item-content class="align-end">{{ block.fieldObject.label }}</v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>Obligatoire ?</v-list-item-content>
          <v-list-item-content class="align-end">{{ block.fieldObject.required ?'Oui':'Non'}}</v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>Séléctionné l'heure ?</v-list-item-content>
          <v-list-item-content class="align-end">{{ block.fieldObject.config.hour ?'Oui':'Non'}}</v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <template v-slot:form="{field,currentService, apiFields}">
      <v-container>
        <v-row>
          <v-col>
            <v-text-field v-model="field.name" label="Nom du champ" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="field.label" label="Etiquette" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-checkbox v-model="field.required" label="Obligatoire ?" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-checkbox v-model="field.config.hour" label="Séléctionné l'heure ?" />
          </v-col>
        </v-row>
        <v-row v-if="currentService.api && apiFields">
          <v-col>
            <v-select
              v-if="apiFields"
              label="Champ API"
              v-model="field.api_field"
              :items="apiFields"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea v-model="field.hint" label="Astuce / Tips / info" />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </FieldWrapper>
</template>

<script>
import iField from "./iField.vue";
export default {
  mixins: [iField],
  name: "FieldDate"
};
</script>
